import styled from "styled-components";

export const AboutStyled = styled.div`
  p:nth-last-child(1) {
    width: 40%;
  }
  @media only screen and (max-width: 768px) {
    p:nth-last-child(1) {
      width: 80%;
    }
  }
  @media only screen and (max-width: 600px) {
    p:nth-last-child(1) {
      width: 100%;
    }
  }
`;
